import React, { useState } from 'react';
import Button from '../../../components/Button';
import Heading from '../../../components/Heading';
import cx from 'classnames';
import styles from './CreateFormModal.module.scss';

interface CreateFormModalProps {
    onConfirm: (name: string) => void;
    onCancel: () => void;
}

const Index: React.FC<CreateFormModalProps> = ({ onConfirm, onCancel }) => {
    const [formName, setFormName] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        
        if (!formName.trim()) {
            return;
        }

        setIsSubmitting(true);
        try {
            onConfirm(formName.trim());
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className={cx(styles['modal-content'])}>
            <div className={cx(styles['modal-heading'])}>
                <Heading level={3} classes="modal-heading">
                    Neues Kontaktformular erstellen
                </Heading>
            </div>

            <form onSubmit={handleSubmit}>
                <div className={cx(styles['form-group'])}>
                    <label 
                        htmlFor="form-name" 
                        className={cx(styles['form-label'])}
                    >
                        Formularname:
                    </label>
                    <input
                        id="form-name"
                        type="text"
                        value={formName}
                        onChange={(e) => setFormName(e.target.value)}
                        placeholder="z.B. Kontaktformular Hauptseite"
                        required
                        autoFocus
                        className={cx(styles['form-input'])}
                    />
                </div>

                <div className={cx(styles['button-container'])}>
                    <Button
                        type="button"
                        hierarchy="secondary"
                        fn={onCancel}
                        disabled={isSubmitting}
                        text="Abbrechen"
                        classes={cx(styles['cancel-button'])}
                    />
                    <Button
                        type="submit"
                        hierarchy="primary"
                        disabled={!formName.trim() || isSubmitting}
                        text={isSubmitting ? 'Erstelle...' : 'Erstellen'}
                        classes={cx(styles['create-button'])}
                    />
                </div>
            </form>
        </div>
    );
};

export default Index;